import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import {
  accept as acceptInvitation,
  reject as rejectInvitation,
} from 'actions/messages';

import { fetchMyself } from 'actions/myself';

import ActionButton from 'components/ActionButton';
import Loading from 'components/Loading';

import TertiaryButton from '../TertiaryButton';
import MessageComponent from '../MessageComponent';

export class InvitationToYou extends Component {
  mounted = false

  state = {
    isAccepting: false,
    isRejecting: false,
  }

  componentDidMount = () => {
    this.mounted = true;
  }

  componentWillUnmount = () => {
    this.mounted = false;
  }

  handleAccept = async () => {
    const { data: { relatedId: invitationId }, dispatch } = this.props;
    if (!invitationId) {
      return;
    }
    this.setState({ isAccepting: true });
    await dispatch(acceptInvitation(invitationId));
    dispatch(fetchMyself());
    if (this.mounted) {
      this.setState({ isAccepting: false });
    }
  }

  handleReject = async () => {
    const { data: { relatedId: invitationId }, dispatch } = this.props;
    this.setState({ isRejecting: true });
    await dispatch(rejectInvitation(invitationId));
    if (this.mounted) {
      this.setState({ isRejecting: false });
    }
  }

  render = () => {
    const {
      actions,
      data,
      disabled: propDisabled,
    } = this.props;
    const {
      isAccepting,
      isRejecting,
    } = this.state;

    const disabled = propDisabled || isAccepting || isRejecting;

    // Build a 'data' object for the ActionButton for simple messages
    const actionData = {
      actionLocked: actions <= 0,
      buttonText: 'Accept',
      isLocked: actions <= 0,
    };

    return (
      <MessageComponent data={data}>
        <TertiaryButton
          disabled={disabled}
          className={classnames(
            'button button--tertiary',
            disabled && 'button--disabled',
          )}
          onClick={this.handleReject}
        >
          {isRejecting ? <Loading spinner small /> : 'Reject'}
        </TertiaryButton>
        <ActionButton
          disabled={disabled}
          suppressUnlockButton
          data={actionData}
          onClick={this.handleAccept}
        >
          {isAccepting && <Loading spinner small />}
        </ActionButton>
      </MessageComponent>
    );
  }
}

InvitationToYou.propTypes = {
  actions: PropTypes.number.isRequired,
  data: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool.isRequired,
};

const mapStateToProps = ({
  actions: { actions },
}) => ({
  actions,
});

export default connect(mapStateToProps)(InvitationToYou);